var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { attrs: { title: "Gestión de CAFs", "title-color": "primary" } },
        [
          _c(
            "vs-button",
            {
              staticStyle: { "margin-bottom": "10px" },
              attrs: { size: "small" },
              on: { click: _vm.agregarCAF }
            },
            [_vm._v("Cargar CAFs")]
          ),
          _c(
            "vs-table",
            {
              attrs: {
                data: _vm.cafs,
                pagination: true,
                maxItems: 6,
                noDataText: "Sin registros encontrados"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var data = ref.data
                    return _vm._l(data, function(tr, indextr) {
                      return _c(
                        "vs-tr",
                        { key: indextr },
                        [
                          _c(
                            "vs-td",
                            {
                              attrs: {
                                data: _vm.traducitTipoDocumentoEnPalabras(
                                  data[indextr].tipoDTE
                                )
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.traducitTipoDocumentoEnPalabras(
                                      data[indextr].tipoDTE
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "vs-td",
                            { attrs: { data: data[indextr].foliosTotales } },
                            [
                              _vm._v(
                                " " + _vm._s(data[indextr].foliosTotales) + " "
                              )
                            ]
                          ),
                          _c(
                            "vs-td",
                            { attrs: { data: data[indextr].foliosUsados } },
                            [
                              _vm._v(
                                " " + _vm._s(data[indextr].foliosUsados) + " "
                              )
                            ]
                          ),
                          _c(
                            "vs-td",
                            { attrs: { data: data[indextr].foliosLibres } },
                            [
                              _vm._v(
                                " " + _vm._s(data[indextr].foliosLibres) + " "
                              )
                            ]
                          ),
                          _c(
                            "vs-td",
                            { attrs: { data: data[indextr].foliosRechazados } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(data[indextr].foliosRechazados) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "vs-td",
                            { attrs: { data: data[indextr].foliosAnulados } },
                            [
                              _vm._v(
                                " " + _vm._s(data[indextr].foliosAnulados) + " "
                              )
                            ]
                          ),
                          _c(
                            "vs-td",
                            { attrs: { data: data[indextr].foliosPorDia } },
                            [
                              _vm._v(
                                " " + _vm._s(data[indextr].foliosPorDia) + " "
                              )
                            ]
                          ),
                          _c(
                            "vs-td",
                            { attrs: { data: data[indextr].diasDisponibles } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(data[indextr].diasDisponibles) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    })
                  }
                }
              ])
            },
            [
              _c(
                "template",
                { slot: "thead" },
                [
                  _c("vs-th", [_vm._v("Tipo documento")]),
                  _c("vs-th", [_vm._v("Folios")]),
                  _c("vs-th", [_vm._v("Usados")]),
                  _c("vs-th", [_vm._v("Libres")]),
                  _c("vs-th", [_vm._v("Rechaz")]),
                  _c("vs-th", [_vm._v("Anulad")]),
                  _c("vs-th", [_vm._v("Uso diario")]),
                  _c("vs-th", [_vm._v("Restantes")])
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _c("modal-cargar", {
        attrs: { editar: _vm.editar },
        on: { cerrarModalCargarCAF: _vm.cerrarModal }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }